import * as React from 'react'

export const EditPermissionContext: React.Context<boolean> = React.createContext<boolean>(false)
